import { jsx as _jsx } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/ChargingStationModelsPage.module.less";
import { canDeleteFromDictionaries, canEditDictionaries, } from "@/utils/permissions";
import { Button, Card, Modal, Skeleton, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DataTable } from "@/components/DataTable";
import { Filters } from "@/components/filters";
export const ChargingStationModelsPage = observer(() => {
    const { authStore, chargingStationModelsStore } = getRootStore();
    const { dataTable, loading, filtersStore } = chargingStationModelsStore;
    const navigate = useNavigate();
    // Определяем права доступа
    const userRole = authStore.userRole;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        dataTable.setFilters(filtersStore.values);
        dataTable.loadData();
    }, [filtersStore.values]);
    const handleViewModel = (modelId) => {
        if (modelId) {
            navigate(`/charging-station-models/${modelId}`);
        }
        else {
            navigate("/charging-station-models/new");
        }
    };
    const handleDeleteModel = (modelId) => {
        Modal.confirm({
            title: "Удалить модель зарядной станции?",
            content: "Вы уверены, что хотите удалить эту модель?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: () => chargingStationModelsStore.deleteModel(modelId),
        });
    };
    const columns = [
        {
            title: "Название",
            key: "name",
            sorter: true,
            dataIndex: "name",
            render: (_, record) => (_jsx(Button, { type: "link", onClick: () => handleViewModel(record.id), children: record.name })),
        },
        {
            title: "Производитель",
            dataIndex: "manufacturerName",
            key: "manufacturerName",
            sorter: true,
            render: (manufacturer) => manufacturer,
        },
        {
            title: "Мощность (кВт)",
            dataIndex: "powerKw",
            key: "powerKw",
            sorter: true,
            render: (power) => `${power} кВт`,
        },
        {
            title: "Количество портов",
            dataIndex: "portCount",
            key: "portCount",
            sorter: true,
            render: (count) => count,
        },
        {
            title: "Макс. ток (А)",
            dataIndex: "maxCurrentA",
            key: "maxCurrentA",
            sorter: true,
            render: (current) => `${current} А`,
        },
        {
            title: "Входное напряжение (В)",
            dataIndex: "inputVoltage",
            key: "inputVoltage",
            sorter: true,
            render: (voltage) => `${voltage} В`,
        },
        {
            title: "Действия",
            key: "actions",
            width: 120,
            render: (_, record) => canDelete && (_jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), danger: true, size: "small", onClick: () => handleDeleteModel(record.id) }) })),
        },
    ];
    const dataTableConfig = {
        header: {
            title: "Модели зарядных станций",
            actions: canEdit ? (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => handleViewModel(), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u044C" })) : undefined,
            extraContent: (_jsx(Filters, { filtersStore: filtersStore, title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u043F\u043E\u0438\u0441\u043A", showClearAll: true, showApplyButton: false })),
        },
        columns: columns,
        rowKey: "id",
        scroll: { x: 1000 },
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return _jsx(DataTable, { store: dataTable, config: dataTableConfig });
});
export default ChargingStationModelsPage;
